export default __webpack_public_path__ + "static/media/screenBlock7.120578cd.jpg";